export var fieldDescriptions = {
    apiBaseUrl: 'The base URL for your API endpoints',
    appIdentifier: 'Unique identifier for your application',
    tokenKey: 'Authentication token key',
    customerSecretKey: 'Secret key for customer authentication',
    userType: 'Select the type of user for this configuration',
    group: 'Select the group associated with this configuration',
    userRole: 'Select the user role associated with this configuration',
    productName: 'Select the product name associated with this configuration',
    signupRoute: 'API endpoint route for signing up a new user',
    isExistsRoute: 'API route to check if a user already exists',
    sendVerifyEmailOtpRoute: 'Route to send verification OTP to user email',
    verifyEmailRoute: 'Endpoint to verify user email with OTP',
    loginRoute: 'API route for user login/authentication',
    validateTokenRoute: 'Endpoint to validate the user’s auth token',
    forgetPasswordSendEmailRoute: 'Route to send a forgot password email to the user',
    forgetPasswordVerifyTokenRoute: 'API endpoint to verify the forgot password token',
    forgetPasswordUpdatePasswordRoute: 'Route to update the user’s password after verification',
};
